import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "overflow-x-auto" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0 whitespace-nowrap" }, "STT", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("small", { class: "text-xs text-muted" }, "(ID)", -1)
const _hoisted_4 = { class: "mb-0 whitespace-nowrap" }
const _hoisted_5 = { class: "text-xs italic text-muted whitespace-nowrap m-0" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0 whitespace-nowrap" }, "Số HĐ", -1)
const _hoisted_7 = { class: "mb-0 whitespace-nowrap break-all" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0 whitespace-nowrap" }, "Loại HĐ", -1)
const _hoisted_9 = { class: "break-all truncate" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0 whitespace-nowrap" }, "Đối tác", -1)
const _hoisted_11 = { class: "break-all truncate" }
const _hoisted_12 = { class: "whitespace-nowrap break-all" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold break-word whitespace-nowrap" }, [
  /*#__PURE__*/_createElementVNode("strong", { class: "break-word" }, "Giá trị")
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("small", { class: "text-xs italic text-muted" }, "(VNĐ)", -1)
const _hoisted_15 = { class: "text-end font-bold whitespace-nowrap" }
const _hoisted_16 = { class: "mb-0 whitespace-nowrap" }
const _hoisted_17 = { class: "mb-0 whitespace-nowrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_Setting = _resolveComponent("Setting")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      "empty-text": "Chưa có dữ liệu hợp đồng",
      size: "medium",
      class: "min-w-full",
      border: true,
      resizable: false,
      data: _ctx.items,
      "row-class-name": _ctx.rowClassName
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          "min-width": "60",
          "class-name": "text-left"
        }, {
          header: _withCtx(() => [
            _hoisted_2,
            _hoisted_3
          ]),
          default: _withCtx((scope) => [
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.indexCal(scope.$index, _ctx.curPage, _ctx.perPage)), 1),
            _createElementVNode("p", _hoisted_5, [
              _createElementVNode("small", null, "(" + _toDisplayString(scope.row.id) + ")", 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { "min-width": "140" }, {
          header: _withCtx(() => [
            _hoisted_6
          ]),
          default: _withCtx((scope) => [
            _createElementVNode("p", _hoisted_7, _toDisplayString(scope.row.so_hop_dong), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { "min-width": "140" }, {
          header: _withCtx(() => [
            _hoisted_8
          ]),
          default: _withCtx((scope) => [
            _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.loaiHopDong(scope.row)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { "min-width": "300" }, {
          header: _withCtx(() => [
            _hoisted_10
          ]),
          default: _withCtx((scope) => [
            _createElementVNode("p", _hoisted_11, _toDisplayString(scope.row.ten_doi_tac), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Mã số thuế",
          "min-width": "150"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("p", _hoisted_12, _toDisplayString(scope.row.ma_so_thue), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          "min-width": "130",
          label: "Giá trị"
        }, {
          header: _withCtx(() => [
            _hoisted_13,
            _hoisted_14
          ]),
          default: _withCtx((scope) => [
            _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.formatAmount(+scope.row.total_value)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Ngày ký",
          "min-width": "120"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.moment(scope.row.ngay_ky).format("DD/MM/YYYY")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Ngày H/hạn",
          "min-width": "120"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("p", _hoisted_17, _toDisplayString(scope.row.ngay_het_han
                ? _ctx.moment(scope.row.ngay_het_han).format("DD/MM/YYYY")
                : "-"), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "",
          width: "50",
          fixed: "right",
          align: "center"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_Setting, {
              actions: _ctx.getSettingActions(scope.row)
            }, null, 8, ["actions"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "row-class-name"])), [
      [_directive_loading, _ctx.isLoading]
    ])
  ]))
}